/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AcceptAiMarksBody } from '../models';
// @ts-ignore
import type { AcceptAiMarksResponse } from '../models';
// @ts-ignore
import type { AnswerSheetStudentsResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { MarkQuizAnswerBody } from '../models';
// @ts-ignore
import type { QuizApproveCleanResponse } from '../models';
// @ts-ignore
import type { QuizReleaseBody } from '../models';
// @ts-ignore
import type { QuizReleaseResponse } from '../models';
// @ts-ignore
import type { QuizReviewAnswer } from '../models';
// @ts-ignore
import type { QuizReviewAttemptResponse } from '../models';
// @ts-ignore
import type { QuizReviewDecisionBody } from '../models';
// @ts-ignore
import type { QuizReviewListResponse } from '../models';
// @ts-ignore
import type { QuizReviewNote } from '../models';
// @ts-ignore
import type { QuizReviewQuestionResponse } from '../models';
// @ts-ignore
import type { QuizReviewQuestionsResponse } from '../models';
// @ts-ignore
import type { QuizSubmissionsResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UploadAnswerSheetResponse } from '../models';
/**
 * QuizReviewApiApi - axios parameter creator
 */
export const QuizReviewApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {AcceptAiMarksBody} acceptAiMarksBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiAcceptAiMarks: async (questionId: string, quizId: string, acceptAiMarksBody: AcceptAiMarksBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('quizReviewApiAcceptAiMarks', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiAcceptAiMarks', 'quizId', quizId)
            // verify required parameter 'acceptAiMarksBody' is not null or undefined
            assertParamExists('quizReviewApiAcceptAiMarks', 'acceptAiMarksBody', acceptAiMarksBody)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/questions/{question_id}/accept-ai-marks`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptAiMarksBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiAnswerSheetStudents: async (quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiAnswerSheetStudents', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/answer-sheets/students`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiApproveClean: async (quizId: string, classId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiApproveClean', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/approve-clean`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {QuizReviewDecisionBody} quizReviewDecisionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiDecideAttempt: async (attemptId: string, quizId: string, quizReviewDecisionBody: QuizReviewDecisionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('quizReviewApiDecideAttempt', 'attemptId', attemptId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiDecideAttempt', 'quizId', quizId)
            // verify required parameter 'quizReviewDecisionBody' is not null or undefined
            assertParamExists('quizReviewApiDecideAttempt', 'quizReviewDecisionBody', quizReviewDecisionBody)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/attempts/{attempt_id}/decision`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizReviewDecisionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {MarkQuizAnswerBody} markQuizAnswerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiMarkQuizAnswer: async (attemptId: string, questionId: string, quizId: string, markQuizAnswerBody: MarkQuizAnswerBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('quizReviewApiMarkQuizAnswer', 'attemptId', attemptId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('quizReviewApiMarkQuizAnswer', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiMarkQuizAnswer', 'quizId', quizId)
            // verify required parameter 'markQuizAnswerBody' is not null or undefined
            assertParamExists('quizReviewApiMarkQuizAnswer', 'markQuizAnswerBody', markQuizAnswerBody)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/attempts/{attempt_id}/answers/{question_id}`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)))
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markQuizAnswerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QuizReviewApiQuizMarksExportFormatEnum} format 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiQuizMarksExport: async (format: QuizReviewApiQuizMarksExportFormatEnum, quizId: string, classId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'format' is not null or undefined
            assertParamExists('quizReviewApiQuizMarksExport', 'format', format)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiQuizMarksExport', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/export`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {QuizReviewApiQuizSubmissionsFilterEnum} [filter] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiQuizSubmissions: async (quizId: string, classId?: string, filter?: QuizReviewApiQuizSubmissionsFilterEnum, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiQuizSubmissions', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizReleaseBody} quizReleaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReleaseMarks: async (quizId: string, quizReleaseBody: QuizReleaseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiReleaseMarks', 'quizId', quizId)
            // verify required parameter 'quizReleaseBody' is not null or undefined
            assertParamExists('quizReviewApiReleaseMarks', 'quizReleaseBody', quizReleaseBody)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/release`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizReleaseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiRemoveUploadedSheet: async (attemptId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('quizReviewApiRemoveUploadedSheet', 'attemptId', attemptId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiRemoveUploadedSheet', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/attempts/{attempt_id}/answer-sheet`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiResetAttempt: async (attemptId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('quizReviewApiResetAttempt', 'attemptId', attemptId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiResetAttempt', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/attempts/{attempt_id}/reset`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiRetryAiMarking: async (attemptId: string, quizId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('quizReviewApiRetryAiMarking', 'attemptId', attemptId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiRetryAiMarking', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/attempts/{attempt_id}/ai-marking`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {QuizReviewApiReviewAttemptFilterEnum} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewAttempt: async (attemptId: string, quizId: string, classId?: string, filter?: QuizReviewApiReviewAttemptFilterEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('quizReviewApiReviewAttempt', 'attemptId', attemptId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiReviewAttempt', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/attempts/{attempt_id}`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QuizReviewApiReviewListTabEnum} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewList: async (tab?: QuizReviewApiReviewListTabEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/faculty/review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewQuestion: async (questionId: string, quizId: string, classId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('quizReviewApiReviewQuestion', 'questionId', questionId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiReviewQuestion', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/questions/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewQuestions: async (quizId: string, classId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiReviewQuestions', 'quizId', quizId)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/questions`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {QuizReviewNote} quizReviewNote 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiSaveAttemptNote: async (attemptId: string, quizId: string, quizReviewNote: QuizReviewNote, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('quizReviewApiSaveAttemptNote', 'attemptId', attemptId)
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiSaveAttemptNote', 'quizId', quizId)
            // verify required parameter 'quizReviewNote' is not null or undefined
            assertParamExists('quizReviewApiSaveAttemptNote', 'quizReviewNote', quizReviewNote)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/attempts/{attempt_id}/note`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)))
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizReviewNote, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} studentId 
         * @param {File} answerSheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiUploadAnswerSheet: async (quizId: string, studentId: string, answerSheet: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizId' is not null or undefined
            assertParamExists('quizReviewApiUploadAnswerSheet', 'quizId', quizId)
            // verify required parameter 'studentId' is not null or undefined
            assertParamExists('quizReviewApiUploadAnswerSheet', 'studentId', studentId)
            // verify required parameter 'answerSheet' is not null or undefined
            assertParamExists('quizReviewApiUploadAnswerSheet', 'answerSheet', answerSheet)
            const localVarPath = `/api/v1/faculty/review/{quiz_id}/answer-sheets`
                .replace('{quiz_id}', encodeURIComponent(String(quizId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (studentId !== undefined) { 
                localVarFormParams.append('student_id', studentId as any);
            }

            if (answerSheet !== undefined) { 
                localVarFormParams.append('answer_sheet', answerSheet as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuizReviewApiApi - functional programming interface
 */
export const QuizReviewApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuizReviewApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {AcceptAiMarksBody} acceptAiMarksBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiAcceptAiMarks(questionId: string, quizId: string, acceptAiMarksBody: AcceptAiMarksBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcceptAiMarksResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiAcceptAiMarks(questionId, quizId, acceptAiMarksBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiAcceptAiMarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiAnswerSheetStudents(quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnswerSheetStudentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiAnswerSheetStudents(quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiAnswerSheetStudents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiApproveClean(quizId: string, classId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizApproveCleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiApproveClean(quizId, classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiApproveClean']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {QuizReviewDecisionBody} quizReviewDecisionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiDecideAttempt(attemptId: string, quizId: string, quizReviewDecisionBody: QuizReviewDecisionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiDecideAttempt(attemptId, quizId, quizReviewDecisionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiDecideAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {MarkQuizAnswerBody} markQuizAnswerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiMarkQuizAnswer(attemptId: string, questionId: string, quizId: string, markQuizAnswerBody: MarkQuizAnswerBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizReviewAnswer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiMarkQuizAnswer(attemptId, questionId, quizId, markQuizAnswerBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiMarkQuizAnswer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QuizReviewApiQuizMarksExportFormatEnum} format 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiQuizMarksExport(format: QuizReviewApiQuizMarksExportFormatEnum, quizId: string, classId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiQuizMarksExport(format, quizId, classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiQuizMarksExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {QuizReviewApiQuizSubmissionsFilterEnum} [filter] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiQuizSubmissions(quizId: string, classId?: string, filter?: QuizReviewApiQuizSubmissionsFilterEnum, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizSubmissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiQuizSubmissions(quizId, classId, filter, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiQuizSubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {QuizReleaseBody} quizReleaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiReleaseMarks(quizId: string, quizReleaseBody: QuizReleaseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizReleaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiReleaseMarks(quizId, quizReleaseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiReleaseMarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiRemoveUploadedSheet(attemptId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiRemoveUploadedSheet(attemptId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiRemoveUploadedSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiResetAttempt(attemptId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiResetAttempt(attemptId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiResetAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiRetryAiMarking(attemptId: string, quizId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiRetryAiMarking(attemptId, quizId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiRetryAiMarking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {QuizReviewApiReviewAttemptFilterEnum} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiReviewAttempt(attemptId: string, quizId: string, classId?: string, filter?: QuizReviewApiReviewAttemptFilterEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizReviewAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiReviewAttempt(attemptId, quizId, classId, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiReviewAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QuizReviewApiReviewListTabEnum} [tab] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiReviewList(tab?: QuizReviewApiReviewListTabEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizReviewListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiReviewList(tab, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiReviewList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiReviewQuestion(questionId: string, quizId: string, classId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizReviewQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiReviewQuestion(questionId, quizId, classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiReviewQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiReviewQuestions(quizId: string, classId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizReviewQuestionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiReviewQuestions(quizId, classId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiReviewQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {string} quizId 
         * @param {QuizReviewNote} quizReviewNote 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiSaveAttemptNote(attemptId: string, quizId: string, quizReviewNote: QuizReviewNote, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizReviewNote>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiSaveAttemptNote(attemptId, quizId, quizReviewNote, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiSaveAttemptNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} quizId 
         * @param {string} studentId 
         * @param {File} answerSheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizReviewApiUploadAnswerSheet(quizId: string, studentId: string, answerSheet: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadAnswerSheetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizReviewApiUploadAnswerSheet(quizId, studentId, answerSheet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizReviewApiApi.quizReviewApiUploadAnswerSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuizReviewApiApi - factory interface
 */
export const QuizReviewApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuizReviewApiApiFp(configuration)
    return {
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiAcceptAiMarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiAcceptAiMarks(requestParameters: QuizReviewApiApiQuizReviewApiAcceptAiMarksRequest, options?: RawAxiosRequestConfig): AxiosPromise<AcceptAiMarksResponse> {
            return localVarFp.quizReviewApiAcceptAiMarks(requestParameters.questionId, requestParameters.quizId, requestParameters.acceptAiMarksBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiAnswerSheetStudentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiAnswerSheetStudents(requestParameters: QuizReviewApiApiQuizReviewApiAnswerSheetStudentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnswerSheetStudentsResponse> {
            return localVarFp.quizReviewApiAnswerSheetStudents(requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiApproveCleanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiApproveClean(requestParameters: QuizReviewApiApiQuizReviewApiApproveCleanRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizApproveCleanResponse> {
            return localVarFp.quizReviewApiApproveClean(requestParameters.quizId, requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiDecideAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiDecideAttempt(requestParameters: QuizReviewApiApiQuizReviewApiDecideAttemptRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.quizReviewApiDecideAttempt(requestParameters.attemptId, requestParameters.quizId, requestParameters.quizReviewDecisionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiMarkQuizAnswerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiMarkQuizAnswer(requestParameters: QuizReviewApiApiQuizReviewApiMarkQuizAnswerRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizReviewAnswer> {
            return localVarFp.quizReviewApiMarkQuizAnswer(requestParameters.attemptId, requestParameters.questionId, requestParameters.quizId, requestParameters.markQuizAnswerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiQuizMarksExportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiQuizMarksExport(requestParameters: QuizReviewApiApiQuizReviewApiQuizMarksExportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.quizReviewApiQuizMarksExport(requestParameters.format, requestParameters.quizId, requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiQuizSubmissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiQuizSubmissions(requestParameters: QuizReviewApiApiQuizReviewApiQuizSubmissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizSubmissionsResponse> {
            return localVarFp.quizReviewApiQuizSubmissions(requestParameters.quizId, requestParameters.classId, requestParameters.filter, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiReleaseMarksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReleaseMarks(requestParameters: QuizReviewApiApiQuizReviewApiReleaseMarksRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizReleaseResponse> {
            return localVarFp.quizReviewApiReleaseMarks(requestParameters.quizId, requestParameters.quizReleaseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiRemoveUploadedSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiRemoveUploadedSheet(requestParameters: QuizReviewApiApiQuizReviewApiRemoveUploadedSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.quizReviewApiRemoveUploadedSheet(requestParameters.attemptId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiResetAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiResetAttempt(requestParameters: QuizReviewApiApiQuizReviewApiResetAttemptRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.quizReviewApiResetAttempt(requestParameters.attemptId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiRetryAiMarkingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiRetryAiMarking(requestParameters: QuizReviewApiApiQuizReviewApiRetryAiMarkingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.quizReviewApiRetryAiMarking(requestParameters.attemptId, requestParameters.quizId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiReviewAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewAttempt(requestParameters: QuizReviewApiApiQuizReviewApiReviewAttemptRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizReviewAttemptResponse> {
            return localVarFp.quizReviewApiReviewAttempt(requestParameters.attemptId, requestParameters.quizId, requestParameters.classId, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiReviewListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewList(requestParameters: QuizReviewApiApiQuizReviewApiReviewListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuizReviewListResponse> {
            return localVarFp.quizReviewApiReviewList(requestParameters.tab, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiReviewQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewQuestion(requestParameters: QuizReviewApiApiQuizReviewApiReviewQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizReviewQuestionResponse> {
            return localVarFp.quizReviewApiReviewQuestion(requestParameters.questionId, requestParameters.quizId, requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiReviewQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiReviewQuestions(requestParameters: QuizReviewApiApiQuizReviewApiReviewQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizReviewQuestionsResponse> {
            return localVarFp.quizReviewApiReviewQuestions(requestParameters.quizId, requestParameters.classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiSaveAttemptNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiSaveAttemptNote(requestParameters: QuizReviewApiApiQuizReviewApiSaveAttemptNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuizReviewNote> {
            return localVarFp.quizReviewApiSaveAttemptNote(requestParameters.attemptId, requestParameters.quizId, requestParameters.quizReviewNote, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuizReviewApiApiQuizReviewApiUploadAnswerSheetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizReviewApiUploadAnswerSheet(requestParameters: QuizReviewApiApiQuizReviewApiUploadAnswerSheetRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadAnswerSheetResponse> {
            return localVarFp.quizReviewApiUploadAnswerSheet(requestParameters.quizId, requestParameters.studentId, requestParameters.answerSheet, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for quizReviewApiAcceptAiMarks operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiAcceptAiMarksRequest {
    readonly questionId: string

    readonly quizId: string

    readonly acceptAiMarksBody: AcceptAiMarksBody
}

/**
 * Request parameters for quizReviewApiAnswerSheetStudents operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiAnswerSheetStudentsRequest {
    readonly quizId: string
}

/**
 * Request parameters for quizReviewApiApproveClean operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiApproveCleanRequest {
    readonly quizId: string

    readonly classId?: string
}

/**
 * Request parameters for quizReviewApiDecideAttempt operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiDecideAttemptRequest {
    readonly attemptId: string

    readonly quizId: string

    readonly quizReviewDecisionBody: QuizReviewDecisionBody
}

/**
 * Request parameters for quizReviewApiMarkQuizAnswer operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiMarkQuizAnswerRequest {
    readonly attemptId: string

    readonly questionId: string

    readonly quizId: string

    readonly markQuizAnswerBody: MarkQuizAnswerBody
}

/**
 * Request parameters for quizReviewApiQuizMarksExport operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiQuizMarksExportRequest {
    readonly format: QuizReviewApiQuizMarksExportFormatEnum

    readonly quizId: string

    readonly classId?: string
}

/**
 * Request parameters for quizReviewApiQuizSubmissions operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiQuizSubmissionsRequest {
    readonly quizId: string

    readonly classId?: string

    readonly filter?: QuizReviewApiQuizSubmissionsFilterEnum

    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for quizReviewApiReleaseMarks operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiReleaseMarksRequest {
    readonly quizId: string

    readonly quizReleaseBody: QuizReleaseBody
}

/**
 * Request parameters for quizReviewApiRemoveUploadedSheet operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiRemoveUploadedSheetRequest {
    readonly attemptId: string

    readonly quizId: string
}

/**
 * Request parameters for quizReviewApiResetAttempt operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiResetAttemptRequest {
    readonly attemptId: string

    readonly quizId: string
}

/**
 * Request parameters for quizReviewApiRetryAiMarking operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiRetryAiMarkingRequest {
    readonly attemptId: string

    readonly quizId: string
}

/**
 * Request parameters for quizReviewApiReviewAttempt operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiReviewAttemptRequest {
    readonly attemptId: string

    readonly quizId: string

    readonly classId?: string

    readonly filter?: QuizReviewApiReviewAttemptFilterEnum
}

/**
 * Request parameters for quizReviewApiReviewList operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiReviewListRequest {
    readonly tab?: QuizReviewApiReviewListTabEnum
}

/**
 * Request parameters for quizReviewApiReviewQuestion operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiReviewQuestionRequest {
    readonly questionId: string

    readonly quizId: string

    readonly classId?: string
}

/**
 * Request parameters for quizReviewApiReviewQuestions operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiReviewQuestionsRequest {
    readonly quizId: string

    readonly classId?: string
}

/**
 * Request parameters for quizReviewApiSaveAttemptNote operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiSaveAttemptNoteRequest {
    readonly attemptId: string

    readonly quizId: string

    readonly quizReviewNote: QuizReviewNote
}

/**
 * Request parameters for quizReviewApiUploadAnswerSheet operation in QuizReviewApiApi.
 */
export interface QuizReviewApiApiQuizReviewApiUploadAnswerSheetRequest {
    readonly quizId: string

    readonly studentId: string

    readonly answerSheet: File
}

/**
 * QuizReviewApiApi - object-oriented interface
 */
export class QuizReviewApiApi extends BaseAPI {
    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiAcceptAiMarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiAcceptAiMarks(requestParameters: QuizReviewApiApiQuizReviewApiAcceptAiMarksRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiAcceptAiMarks(requestParameters.questionId, requestParameters.quizId, requestParameters.acceptAiMarksBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiAnswerSheetStudentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiAnswerSheetStudents(requestParameters: QuizReviewApiApiQuizReviewApiAnswerSheetStudentsRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiAnswerSheetStudents(requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiApproveCleanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiApproveClean(requestParameters: QuizReviewApiApiQuizReviewApiApproveCleanRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiApproveClean(requestParameters.quizId, requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiDecideAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiDecideAttempt(requestParameters: QuizReviewApiApiQuizReviewApiDecideAttemptRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiDecideAttempt(requestParameters.attemptId, requestParameters.quizId, requestParameters.quizReviewDecisionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiMarkQuizAnswerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiMarkQuizAnswer(requestParameters: QuizReviewApiApiQuizReviewApiMarkQuizAnswerRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiMarkQuizAnswer(requestParameters.attemptId, requestParameters.questionId, requestParameters.quizId, requestParameters.markQuizAnswerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiQuizMarksExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiQuizMarksExport(requestParameters: QuizReviewApiApiQuizReviewApiQuizMarksExportRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiQuizMarksExport(requestParameters.format, requestParameters.quizId, requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiQuizSubmissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiQuizSubmissions(requestParameters: QuizReviewApiApiQuizReviewApiQuizSubmissionsRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiQuizSubmissions(requestParameters.quizId, requestParameters.classId, requestParameters.filter, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiReleaseMarksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiReleaseMarks(requestParameters: QuizReviewApiApiQuizReviewApiReleaseMarksRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiReleaseMarks(requestParameters.quizId, requestParameters.quizReleaseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiRemoveUploadedSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiRemoveUploadedSheet(requestParameters: QuizReviewApiApiQuizReviewApiRemoveUploadedSheetRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiRemoveUploadedSheet(requestParameters.attemptId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiResetAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiResetAttempt(requestParameters: QuizReviewApiApiQuizReviewApiResetAttemptRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiResetAttempt(requestParameters.attemptId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiRetryAiMarkingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiRetryAiMarking(requestParameters: QuizReviewApiApiQuizReviewApiRetryAiMarkingRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiRetryAiMarking(requestParameters.attemptId, requestParameters.quizId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiReviewAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiReviewAttempt(requestParameters: QuizReviewApiApiQuizReviewApiReviewAttemptRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiReviewAttempt(requestParameters.attemptId, requestParameters.quizId, requestParameters.classId, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiReviewListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiReviewList(requestParameters: QuizReviewApiApiQuizReviewApiReviewListRequest = {}, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiReviewList(requestParameters.tab, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiReviewQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiReviewQuestion(requestParameters: QuizReviewApiApiQuizReviewApiReviewQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiReviewQuestion(requestParameters.questionId, requestParameters.quizId, requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiReviewQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiReviewQuestions(requestParameters: QuizReviewApiApiQuizReviewApiReviewQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiReviewQuestions(requestParameters.quizId, requestParameters.classId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiSaveAttemptNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiSaveAttemptNote(requestParameters: QuizReviewApiApiQuizReviewApiSaveAttemptNoteRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiSaveAttemptNote(requestParameters.attemptId, requestParameters.quizId, requestParameters.quizReviewNote, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuizReviewApiApiQuizReviewApiUploadAnswerSheetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizReviewApiUploadAnswerSheet(requestParameters: QuizReviewApiApiQuizReviewApiUploadAnswerSheetRequest, options?: RawAxiosRequestConfig) {
        return QuizReviewApiApiFp(this.configuration).quizReviewApiUploadAnswerSheet(requestParameters.quizId, requestParameters.studentId, requestParameters.answerSheet, options).then((request) => request(this.axios, this.basePath));
    }
}

export const QuizReviewApiQuizMarksExportFormatEnum = {
    Csv: 'csv',
    Xlsx: 'xlsx',
    Pdf: 'pdf',
} as const;
export type QuizReviewApiQuizMarksExportFormatEnum = typeof QuizReviewApiQuizMarksExportFormatEnum[keyof typeof QuizReviewApiQuizMarksExportFormatEnum];
export const QuizReviewApiQuizSubmissionsFilterEnum = {
    All: 'all',
    Flagged: 'flagged',
    Clean: 'clean',
    Reviewed: 'reviewed',
    NotReviewed: 'not_reviewed',
} as const;
export type QuizReviewApiQuizSubmissionsFilterEnum = typeof QuizReviewApiQuizSubmissionsFilterEnum[keyof typeof QuizReviewApiQuizSubmissionsFilterEnum];
export const QuizReviewApiReviewAttemptFilterEnum = {
    All: 'all',
    Flagged: 'flagged',
    Clean: 'clean',
    Reviewed: 'reviewed',
    NotReviewed: 'not_reviewed',
} as const;
export type QuizReviewApiReviewAttemptFilterEnum = typeof QuizReviewApiReviewAttemptFilterEnum[keyof typeof QuizReviewApiReviewAttemptFilterEnum];
export const QuizReviewApiReviewListTabEnum = {
    Needs: 'needs',
    Marked: 'marked',
} as const;
export type QuizReviewApiReviewListTabEnum = typeof QuizReviewApiReviewListTabEnum[keyof typeof QuizReviewApiReviewListTabEnum];
